import { Box, Button, Modal } from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Stepper, Step } from "react-form-stepper";

import StepWizard from "react-step-wizard";
import { IoArrowBackOutline, IoArrowForwardOutline } from "react-icons/io5";

import animate from "../Vendor/animate.module.css";
import { toast } from "react-hot-toast";
import { useFetchVendorsQuery } from "../../../features/admin/vendor/vendorApi";
import ReorderList from "../../../components/ReorderList/ReorderList";
import { useNavigate } from "react-router-dom";
import {
  useAddAppUserDashboardMutation,
  useFetchAllDashboardItemsMutation,
  useUpdateAppUserDashboardMutation,
} from "../../../features/admin/appUserDashboard/appUserDashboardApi";
import { BsCheckCircleFill, BsCircle } from "react-icons/bs";
import { FaPencilAlt, FaTrashAlt } from "react-icons/fa";
import { useUploadSingleFileMutation } from "../../../features/admin/imageUpload/imageUploadApi";
import "../Vendor/wizard.css";
import {
  normalizeIconUrl,
  resolveIconWithFallback,
} from "../../../utils/appItemIcon";
import {
  addCheckedKeyToItems,
  mergeAppItemsByAction,
  nextCustomItemId,
  normalizeActionKey,
} from "../../../utils/mergeAppItemsByAction";

// Previously inline: mergeDashboardItemsWithExisting (matched by id only).
// Update flow now uses mergeAppItemsByAction in utils/mergeAppItemsByAction.js
// (tenant JSON first, master fills gaps, dedupe by action).

const cloneDashboardList = (list = []) =>
  list.map((item, idx) => ({
    ...item,
    order: item.order ?? item.order_at ?? idx + 1,
  }));

const formatDashboardPayload = (items) =>
  [...items]
    .sort((a, b) => (a.order ?? a.order_at ?? 0) - (b.order ?? b.order_at ?? 0))
    .map((item, idx) => {
      const payload = { ...item };
      payload.order_at = item.order ?? item.order_at ?? idx + 1;
      delete payload.order;
      delete payload.checked;
      delete payload.companyOverride;
      delete payload.tenantOnly;
      delete payload.__sourceIndex;
      delete payload.created_at;
      delete payload.created_by_id;
      delete payload.created_by_name;
      return payload;
    });

const editModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: 560,
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 8,
  p: 3,
};

const ActionButtons = (props) => {
  const handleBack = () => {
    props.previousStep();
  };

  const handleNext = () => {
    props.nextStep();
  };

  const handleFinish = () => {
    props.lastStep();
  };

  return (
    <div className="mt-4">
      <div className="d-flex  justify-content-center align-items-center space-x-3 ">
        {props.currentStep > 1 && (
          <div>
            <Button
              startIcon={<IoArrowBackOutline />}
              variant="outlined"
              onClick={handleBack}
            >
              Back
            </Button>
          </div>
        )}
        <div>
          {props.currentStep < props.totalSteps && (
            <Button
              variant="outlined"
              endIcon={<IoArrowForwardOutline />}
              color="success"
              onClick={handleNext}
              disabled={props.isLoading}
            >
              {props.isLoading ? "Saving..." : "Next"}
            </Button>
          )}
          {props.currentStep === props.totalSteps && (
            <Button variant="contained" color="success" onClick={handleFinish}>
              Finish
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

const BasicSetup = (props) => {
  const [vendorsList, setVendorsList] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(
    props.myData?.selectedVendor || 0,
  );
  const [selectedVendorData, setSelectedVendorData] = useState(
    props.myData?.selectedVendorData || null,
  );
  const [usersList, setUsersList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(
    props.myData?.selectedUser || null,
  );

  const {
    data: vendorsData,
    isError: vendorsIsError,
    isLoading: vendorsIsLoading,
    error: vendorsError,
  } = useFetchVendorsQuery(sessionStorage.getItem("access_token")) || {};

  useMemo(() => {
    if (vendorsData) {
      (() => {
        setVendorsList(vendorsData.body);
      })();
    }
    if (vendorsError) {
      toast.error(vendorsError.error, {
        id: "vendorsError",
      });
    }
  }, [vendorsData, vendorsError]);

  useEffect(() => {
    if (!vendorsList.length || !props.myData?.selectedVendorData) {
      return;
    }

    const vendor = vendorsList.find(
      (item) => item.tenant_id === props.myData.selectedVendorData.tenant_id,
    );

    if (vendor) {
      setSelectedVendor(vendor.company_id);
      setSelectedVendorData(vendor);
      setUsersList(vendor.user_types || []);
      setSelectedUser(props.myData.selectedUser);
    }
  }, [vendorsList, props.myData]);

  const handleVendorChange = (event) => {
    setSelectedVendor(event.target.value);
    vendorsList.forEach(function (data) {
      if (data.company_id == event.target.value) {
        setSelectedVendorData(data);
        setUsersList(data.user_types);
      }
    });
  };

  useEffect(() => {
    toast.dismiss();
    // console.log(selectedUser , selectedVendor.product_availing);
    if (selectedUser && selectedVendorData.product_availing) {
    }
  }, [selectedUser, selectedVendor]);

  const basicSetupValidate = () => {
    // console.log("basic setup validate--------------->>>>>>>>>",selectedVendor , selectedUser);
    if (selectedVendor == 0 || selectedUser == 0) {
      return;
    }

    const obj = {
      ...props.myData,
      selectedVendor: selectedVendor,
      selectedVendorData: selectedVendorData,
      selectedUser: selectedUser,
      user_type_id: props.myData?.user_type_id,
    };

    props.nextStep();
    props.vendorDataCallback(obj);
  };

  return (
    <div className="autox">
      <div className="cmxform formsstep_n1 width50 mt-4">
        <div className="row">
          <div className="col-12  my-2">
            <label className="text-capitalize font-weight-bold">
              Choose Client *
            </label>
            <select
              className="js-example-basic-single w-100 rounded-lg shadow-sm shadow-black"
              value={selectedVendor}
              onChange={handleVendorChange}
            >
              <option value={0}>Select Client</option>
              {vendorsList &&
                vendorsList.map((vendor) => (
                  <option key={vendor.id} value={vendor.company_id}>
                    {vendor.name}
                  </option>
                ))}
            </select>
          </div>

          <div className="col-12  mt-4">
            <label className="text-capitalize font-weight-bold">
              Choose User *
            </label>
            <select
              className="js-example-basic-single w-100 rounded-lg shadow-sm shadow-black"
              value={selectedUser}
              onChange={(e) => setSelectedUser(e.target.value)}
            >
              <option value={0}>Select User</option>
              {usersList &&
                usersList.map((user, idx) => (
                  <option key={idx} value={user}>
                    {user}
                  </option>
                ))}
            </select>
          </div>
        </div>
      </div>

      <ActionButtons {...props} nextStep={basicSetupValidate} />
    </div>
  );
};

const DashboardSetup = (props) => {
  // console.log("DashboardSetup receive vendorData object");
  const [error, setError] = useState("");

  const [
    fetchDashboardItems,
    {
      data: appDashboardData,
      isLoading: appDashboardIsLoading,
      error: appDashboardError,
    },
  ] = useFetchAllDashboardItemsMutation();

  const [selectedVendor, setSelectedVendor] = useState(
    props.myData.selectedVendor,
  );
  const [selectedVendorData, setSelectedVendorData] = useState(
    props.myData.selectedVendorData,
  );
  const [selectedUser, setSelectedUser] = useState(props.myData.selectedUser);

  const [allMenuItems, setAllMenuItems] = useState([]);
  const [uploadSingleFile, { isLoading: isUploadingIcon }] = useUploadSingleFileMutation();
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editSourceIndex, setEditSourceIndex] = useState(null);
  const [editForm, setEditForm] = useState({
    name: "",
    action: "",
    link: "",
    order_at: "",
    icon: null,
  });
  const [addForm, setAddForm] = useState({
    id: "",
    name: "",
    action: "",
    link: "",
    order_at: "",
    icon: null,
  });
  const [iconPreview, setIconPreview] = useState(null);
  const [addIconPreview, setAddIconPreview] = useState(null);
  const [isSavingSelection, setIsSavingSelection] = useState(false);
  const listInitializedKeyRef = useRef(null);

  const getCheckedItems = (items = []) =>
    items
      .filter((item) => item.checked)
      .map((item) => ({
        ...item,
        order: item.order ?? item.order_at,
      }));

  const persistCheckedItems = async (
    items,
    { showToast = true, allowEmpty = false } = {},
  ) => {
    if (!props.isUpdateMode || !props.persistTenantDashboard) {
      return { saved: true };
    }

    const checked = getCheckedItems(items);
    if (!checked.length && !allowEmpty) {
      if (showToast) {
        toast.error("Please select at least one dashboard item");
      }
      return { saved: false };
    }

    setIsSavingSelection(true);
    try {
      const result = await props.persistTenantDashboard(checked, {
        allowEmpty,
      });
      if (result?.saved && showToast) {
        toast.success("Client dashboard saved");
      }
      return result;
    } finally {
      setIsSavingSelection(false);
    }
  };

  // console.log("DashboardSetup", props.myData);

  useEffect(() => {
    if (props.myData?.selectedUser && !appDashboardData) {
      fetchDashboardItems({ token: sessionStorage.getItem("access_token") });
    }

    setSelectedVendor(props.myData?.selectedVendor);
    setSelectedUser(props.myData?.selectedUser);
    setSelectedVendorData(props.myData?.selectedVendorData);
  }, [
    props.myData?.selectedUser,
    props.myData?.selectedVendor,
    props.myData?.selectedVendorData,
    props.myData?.existingDashboard,
    appDashboardData,
  ]);

  useEffect(() => {
    if (!appDashboardData?.body) return;

    const initKey = [
      props.isUpdateMode ? "update" : "create",
      props.myData?.recordId ?? "",
      props.myData?.selectedUser ?? "",
      props.myData?.selectedVendorData?.tenant_id ?? "",
    ].join("|");

    if (listInitializedKeyRef.current === initKey) return;

    const masterItems = appDashboardData.body || [];
    const newArray = props.isUpdateMode
      ? mergeAppItemsByAction(
          masterItems,
          props.myData?.existingDashboard || [],
        )
      : addCheckedKeyToItems(masterItems);

    setAllMenuItems(newArray);
    listInitializedKeyRef.current = initKey;
  }, [
    appDashboardData,
    props.isUpdateMode,
    props.myData?.existingDashboard,
    props.myData?.recordId,
    props.myData?.selectedUser,
    props.myData?.selectedVendorData?.tenant_id,
  ]);

  useEffect(() => {
    if (appDashboardError) {
      console.log("app dashboard error", appDashboardError);
      toast.error("Something went wrong", { id: "app dashboard error" });
    }
  }, [appDashboardError]);

  const handleOnChange = (idx) => {
    const newData = [...allMenuItems];
    newData[idx].checked = !allMenuItems[idx].checked;
    setAllMenuItems(newData);
  };

  const handleRemoveItem = async (sourceIndex, e) => {
    e.stopPropagation();
    const item = allMenuItems[sourceIndex];
    if (!item) return;

    if (
      !window.confirm(
        `Remove "${item.name}" from this client's dashboard?`,
      )
    ) {
      return;
    }

    const nextList = item.tenantOnly
      ? allMenuItems.filter((_, i) => i !== sourceIndex)
      : allMenuItems.map((it, i) =>
          i === sourceIndex ? { ...it, checked: false } : it,
        );

    setAllMenuItems(nextList);

    if (props.isUpdateMode) {
      const hasChecked = getCheckedItems(nextList).length > 0;
      const result = await persistCheckedItems(nextList, {
        showToast: true,
        allowEmpty: !hasChecked,
      });
      if (!result?.saved) return;
    }

    toast.success("Item removed from this client");
  };

  const openEditModal = (sourceIndex) => {
    const selectedItem = allMenuItems[sourceIndex];
    if (!selectedItem) return;

    setEditSourceIndex(sourceIndex);
    setEditForm({
      name: selectedItem.name || "",
      action: selectedItem.action || "",
      link: selectedItem.link || "",
      order_at: String(selectedItem.order_at || ""),
      icon: null,
    });
    setIconPreview(normalizeIconUrl(selectedItem.icon) || null);
    setEditModalOpen(true);
  };

  const closeEditModal = () => {
    setEditModalOpen(false);
    setEditSourceIndex(null);
    setEditForm({
      name: "",
      action: "",
      link: "",
      order_at: "",
      icon: null,
    });
    setIconPreview(null);
  };

  const handleEditFieldChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "icon") {
      const file = files?.[0] || null;
      setEditForm((prev) => ({ ...prev, icon: file }));
      if (file) {
        setIconPreview(URL.createObjectURL(file));
      }
      return;
    }
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const saveEditedItem = async () => {
    if (editSourceIndex === null) return;
    if (!editForm.name || !editForm.action || !editForm.link || !editForm.order_at) {
      toast.error("Please fill all required fields");
      return;
    }

    let finalIcon = allMenuItems[editSourceIndex]?.icon;
    if (editForm.icon) {
      try {
        const formData = new FormData();
        formData.append("image", editForm.icon);
        const response = await uploadSingleFile({
          token: sessionStorage.getItem("access_token"),
          body: formData,
        }).unwrap();
        finalIcon = response?.body?.fileLink || finalIcon;
      } catch (error) {
        toast.error(error?.data?.message || "Failed to upload icon");
        return;
      }
    }

    const nextList = allMenuItems.map((item, idx) =>
      idx === editSourceIndex
        ? (() => {
            const icons = resolveIconWithFallback(
              finalIcon,
              item.fallbackIcon || item.icon,
            );
            return {
              ...item,
              name: editForm.name.trim(),
              action: editForm.action.trim(),
              link: editForm.link.trim(),
              order_at: Number(editForm.order_at),
              order: Number(editForm.order_at),
              icon: icons.primaryIcon,
              primaryIcon: icons.primaryIcon,
              fallbackIcon: icons.fallbackIcon,
              checked: true,
              companyOverride: true,
            };
          })()
        : item,
    );

    setAllMenuItems(nextList);

    if (props.isUpdateMode) {
      const result = await persistCheckedItems(nextList, { showToast: true });
      if (!result?.saved) return;
    } else {
      toast.success("Item updated");
    }

    closeEditModal();
  };

  const openAddModal = () => {
    setAddForm({
      id: String(nextCustomItemId(allMenuItems)),
      name: "",
      action: "",
      link: "",
      order_at: String((allMenuItems.length || 0) + 1),
      icon: null,
    });
    setAddIconPreview(null);
    setAddModalOpen(true);
  };

  const closeAddModal = () => {
    setAddModalOpen(false);
    setAddForm({
      id: "",
      name: "",
      action: "",
      link: "",
      order_at: "",
      icon: null,
    });
    setAddIconPreview(null);
  };

  const handleAddFieldChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "icon") {
      const file = files?.[0] || null;
      setAddForm((prev) => ({ ...prev, icon: file }));
      if (file) setAddIconPreview(URL.createObjectURL(file));
      return;
    }
    setAddForm((prev) => ({ ...prev, [name]: value }));
  };

  const saveNewItem = async () => {
    if (
      !addForm.id ||
      !addForm.name ||
      !addForm.action ||
      !addForm.link ||
      !addForm.order_at
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    const actionKey = normalizeActionKey(addForm.action);
    if (
      allMenuItems.some(
        (item) => normalizeActionKey(item.action) === actionKey,
      )
    ) {
      toast.error("An item with this action already exists");
      return;
    }

    let finalIcon = "";
    if (addForm.icon) {
      try {
        const formData = new FormData();
        formData.append("image", addForm.icon);
        const response = await uploadSingleFile({
          token: sessionStorage.getItem("access_token"),
          body: formData,
        }).unwrap();
        finalIcon = response?.body?.fileLink || "";
      } catch (error) {
        toast.error(error?.data?.message || "Failed to upload icon");
        return;
      }
    }

    const icons = resolveIconWithFallback(finalIcon, finalIcon);
    const nextList = [
      ...allMenuItems,
      {
        id: Number(addForm.id),
        name: addForm.name.trim(),
        action: addForm.action.trim(),
        link: addForm.link.trim(),
        order_at: Number(addForm.order_at),
        order: Number(addForm.order_at),
        icon: icons.primaryIcon,
        primaryIcon: icons.primaryIcon,
        fallbackIcon: icons.fallbackIcon,
        checked: true,
        tenantOnly: true,
        companyOverride: true,
      },
    ];

    setAllMenuItems(nextList);

    if (props.isUpdateMode) {
      const result = await persistCheckedItems(nextList, { showToast: true });
      if (!result?.saved) return;
    } else {
      toast.success("Item added");
    }

    closeAddModal();
  };

  const previewButton = async () => {
    // console.log(selectedUser, selectedVendorData);

    if (allMenuItems && selectedVendorData && selectedUser) {
      const arr = [];

      for (let index = 0; index < allMenuItems.length; index++) {
        const element = allMenuItems[index];
        if (element.checked) {
          arr.push({
            ...element,
            order: element.order_at,
          });
        }
      }

      if (arr.length > 0) {
        if (props.isUpdateMode) {
          const result = await persistCheckedItems(allMenuItems, {
            showToast: false,
          });
          if (!result?.saved) return;
        }

        const obj = {
          ...props.myData,
          orderList: cloneDashboardList(arr),
          finalProgramList: cloneDashboardList(arr),
        };

        props.vendorDataCallback(obj);
        props.nextStep();
        return;
      }

      setError("Please select at least one dashboard item");
    }
  };

  const setupValidate = () => {
    setError("");
    previewButton();
  };

  const displayDashboardItems = [...allMenuItems]
    .map((item, index) => ({ ...item, __sourceIndex: index }))
    .sort((a, b) => Number(a.order_at ?? 0) - Number(b.order_at ?? 0));

  return (
    <div className="card">
      <div className="card-body px-5">
        <h5 className="text-center font-weight-bold mb-2">Choose Dashboard Items</h5>
        <p className="text-muted small mb-3 text-center">
          Client dashboard items are shown first, then master items. Same action
          uses the client version.
        </p>

        {props.isUpdateMode && (
          <div className="text-center mb-3">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={openAddModal}
            >
              + Add client-only item
            </button>
          </div>
        )}

        <div className="row px-2">
          {appDashboardIsLoading && (
            <div className="col-12 text-center py-3 text-muted">
              Loading dashboard items...
            </div>
          )}
          {!appDashboardIsLoading && allMenuItems.length === 0 && (
            <div className="col-12 text-center py-3 text-muted">
              No dashboard items found.
            </div>
          )}
          {displayDashboardItems.map((item, idx) => (
            <div key={`${item.id}-${idx}`} className="col-12 col-sm-6 col-lg-4 mb-3">
              <div
                role="button"
                tabIndex={0}
                onClick={() => handleOnChange(item.__sourceIndex)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ")
                    handleOnChange(item.__sourceIndex);
                }}
                className="card h-100"
                style={{
                  cursor: "pointer",
                  border: item.checked ? "1px solid #3b82f6" : "1px solid #e5e7eb",
                  backgroundColor: item.checked ? "#eef4ff" : "#fff",
                  borderRadius: 10,
                  padding: "10px 12px",
                }}
              >
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="badge badge-primary badge-pill">
                    #{item.order_at ?? idx + 1}
                    {item.tenantOnly ? " · client" : ""}
                  </span>
                  <div className="d-flex align-items-center" style={{ gap: 4 }}>
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm p-1"
                      onClick={(e) => {
                        e.stopPropagation();
                        openEditModal(item.__sourceIndex);
                      }}
                      title="Edit item"
                    >
                      <FaPencilAlt size={12} />
                    </button>
                    {props.isUpdateMode &&
                      (item.checked || item.tenantOnly) && (
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm p-1"
                          onClick={(e) =>
                            handleRemoveItem(item.__sourceIndex, e)
                          }
                          title="Remove from this client"
                          disabled={isSavingSelection}
                        >
                          <FaTrashAlt size={12} />
                        </button>
                      )}
                  </div>
                </div>

                <div className="d-flex align-items-start">
                  <div className="mr-2 mt-1">
                    {item.checked ? (
                      <BsCheckCircleFill style={{ color: "#2563eb", fontSize: "14px" }} />
                    ) : (
                      <BsCircle style={{ color: "#6b7280", fontSize: "14px" }} />
                    )}
                  </div>

                  <img
                    src={item.primaryIcon || normalizeIconUrl(item.icon)}
                    alt={item.name}
                    onError={(e) => {
                      const nextSrc = item.fallbackIcon || normalizeIconUrl(item.icon);
                      if (nextSrc && e.currentTarget.src !== nextSrc) {
                        e.currentTarget.src = nextSrc;
                        return;
                      }
                      e.currentTarget.onerror = null;
                      e.currentTarget.src =
                        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='3' width='18' height='18' rx='2' ry='2'/%3E%3Ccircle cx='8.5' cy='8.5' r='1.5'/%3E%3Cpath d='M21 15l-5-5L5 21'/%3E%3C/svg%3E";
                    }}
                    style={{
                      width: 28,
                      height: 28,
                      objectFit: "contain",
                      marginRight: 10,
                      flexShrink: 0,
                    }}
                  />

                  <div style={{ minWidth: 0 }}>
                    <div
                      style={{
                        fontSize: "0.84rem",
                        fontWeight: 600,
                        lineHeight: 1.25,
                        marginBottom: 3,
                      }}
                    >
                      {item.name}
                    </div>
                    <div
                      style={{
                        fontSize: "0.7rem",
                        color: "#6b7280",
                        lineHeight: 1.25,
                        wordBreak: "break-word",
                      }}
                    >
                      {item.action}
                    </div>
                    <div
                      style={{
                        fontSize: "0.7rem",
                        color: "#9ca3af",
                        lineHeight: 1.25,
                        wordBreak: "break-word",
                      }}
                    >
                      {item.link}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mb-3" style={{ color: "red" }}>
          {error}
        </div>

        <Modal open={addModalOpen} onClose={closeAddModal}>
          <Box sx={editModalStyle}>
            <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
              <h6 className="mb-0 font-weight-bold">Add Client Dashboard Item</h6>
            </div>
            <div className="row">
              <div className="col-md-6 form-group mb-3">
                <label className="small font-weight-bold d-block mb-1">ID *</label>
                <input className="form-control" name="id" type="number" value={addForm.id} onChange={handleAddFieldChange} min={1} />
              </div>
              <div className="col-md-6 form-group mb-3">
                <label className="small font-weight-bold d-block mb-1">Name *</label>
                <input className="form-control" name="name" value={addForm.name} onChange={handleAddFieldChange} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 form-group mb-3">
                <label className="small font-weight-bold d-block mb-1">Action *</label>
                <input className="form-control" name="action" value={addForm.action} onChange={handleAddFieldChange} />
              </div>
              <div className="col-md-6 form-group mb-3">
                <label className="small font-weight-bold d-block mb-1">Link *</label>
                <input className="form-control" name="link" value={addForm.link} onChange={handleAddFieldChange} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 form-group mb-3">
                <label className="small font-weight-bold d-block mb-1">Order *</label>
                <input type="number" className="form-control" name="order_at" value={addForm.order_at} onChange={handleAddFieldChange} min={1} />
              </div>
              <div className="col-md-6 form-group mb-3">
                <label className="small font-weight-bold d-block mb-1">Icon</label>
                <input type="file" name="icon" accept="image/*" className="form-control" onChange={handleAddFieldChange} />
                {addIconPreview ? (
                  <div className="mt-2">
                    <img src={addIconPreview} alt="Icon preview" style={{ width: 56, height: 56, objectFit: "contain" }} />
                  </div>
                ) : null}
              </div>
            </div>
            <div className="d-flex justify-content-end gap-2 pt-2 border-top">
              <button type="button" className="btn btn-outline-secondary btn-sm" onClick={closeAddModal}>Cancel</button>
              <button type="button" className="btn btn-primary btn-sm px-4" onClick={saveNewItem} disabled={isUploadingIcon}>
                {isUploadingIcon ? "Saving..." : "Add"}
              </button>
            </div>
          </Box>
        </Modal>

        <Modal open={editModalOpen} onClose={closeEditModal}>
          <Box sx={editModalStyle}>
            <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
              <h6 className="mb-0 font-weight-bold">Update Dashboard Item</h6>
            </div>
            <div className="row">
              <div className="col-md-6 form-group mb-3">
                <label className="small font-weight-bold d-block mb-1">Name *</label>
                <input className="form-control" name="name" value={editForm.name} onChange={handleEditFieldChange} />
              </div>
              <div className="col-md-6 form-group mb-3">
                <label className="small font-weight-bold d-block mb-1">Action *</label>
                <input className="form-control" name="action" value={editForm.action} onChange={handleEditFieldChange} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 form-group mb-3">
                <label className="small font-weight-bold d-block mb-1">Link *</label>
                <input className="form-control" name="link" value={editForm.link} onChange={handleEditFieldChange} />
              </div>
              <div className="col-md-6 form-group mb-3">
                <label className="small font-weight-bold d-block mb-1">Order *</label>
                <input type="number" className="form-control" name="order_at" value={editForm.order_at} onChange={handleEditFieldChange} min={1} />
              </div>
            </div>
            <div className="form-group mb-3">
              <label className="small font-weight-bold d-block mb-2">Icon</label>
              <input type="file" name="icon" accept="image/*" className="form-control" onChange={handleEditFieldChange} />
              {iconPreview ? (
                <div className="mt-2">
                  <img src={iconPreview} alt="Icon preview" style={{ width: 56, height: 56, objectFit: "contain" }} />
                </div>
              ) : null}
            </div>
            <div className="d-flex justify-content-end gap-2 pt-2 border-top">
              <button type="button" className="btn btn-outline-secondary btn-sm" onClick={closeEditModal}>Cancel</button>
              <button type="button" className="btn btn-primary btn-sm px-4" onClick={saveEditedItem} disabled={isUploadingIcon}>
                {isUploadingIcon ? "Saving..." : "Save"}
              </button>
            </div>
          </Box>
        </Modal>

        <ActionButtons
          {...props}
          nextStep={setupValidate}
          isLoading={isSavingSelection}
        />
      </div>
    </div>
  );
};

const LastStep = (props) => {
  // console.log("Last Step receive vendorData object" ,props.myData);

  const [selectedUser, setSelectedUser] = useState(
    props.myData?.selectedUser ? props.myData.selectedUser : null,
  );

  const [orderList, setOrderList] = useState(() =>
    cloneDashboardList(props.myData?.orderList),
  );
  const [finalProgramList, setFinalProgramList] = useState(() =>
    cloneDashboardList(props.myData?.finalProgramList),
  );

  useEffect(() => {
    setSelectedUser(
      props.myData?.selectedUser ? props.myData.selectedUser : null,
    );
    setOrderList(cloneDashboardList(props.myData?.orderList));
    setFinalProgramList(cloneDashboardList(props.myData?.finalProgramList));
  }, [props.myData]);

  const handleLastStep = () => {
    const latestList = cloneDashboardList(finalProgramList);
    props.vendorDataCallback({
      orderList: latestList,
      finalProgramList: latestList,
    });
    props.lastStep();
    props.completeCallback(latestList);
  };

  return (
    <div className="autox">
      <div className="cmxform  mt-4">
        <div className="w-100 d-flex flex-column justify-content-center align-items-center mb-4">
          <h2 className="titletxt">
            {selectedUser &&
              selectedUser.length > 0 &&
              selectedUser.charAt(0).toUpperCase() + selectedUser.slice(1)}{" "}
            Dashboard
          </h2>
          <div className="col-md-6">
            {orderList.length > 0 ? (
              <ReorderList
                list={orderList}
                setList={setFinalProgramList}
                type={"menu"}
              />
            ) : null}
          </div>
        </div>

        <ActionButtons {...props} lastStep={handleLastStep} />
      </div>
    </div>
  );
};

const buildEditMyData = (editData) => {
  const existingDashboard = cloneDashboardList(
    Array.isArray(editData?.app_dashboard) ? editData.app_dashboard : [],
  );

  return {
    selectedVendorData: {
      tenant_id: editData.tenant_id,
      name: editData.tenant_name,
    },
    selectedUser: editData.user_type,
    user_type_id: editData.user_type_id,
    existingDashboard,
    recordId: editData.id,
    orderList: [],
    finalProgramList: [],
  };
};

const AppDashboardWizard = ({
  handleClose,
  refetch,
  mode = "create",
  editData = null,
  initialStep = 1,
}) => {
  const isUpdateMode = mode === "update";
  const [stepWizard, setStepWizard] = useState(null);
  const [myData, setMyData] = useState(() =>
    isUpdateMode && editData ? buildEditMyData(editData) : {},
  );
  const [activeStep, setActiveStep] = useState(
    initialStep > 1 ? initialStep - 1 : 0,
  );

  const navigate = useNavigate();

  const assignStepWizard = (instance) => {
    setStepWizard(instance);
    if (instance && initialStep > 1) {
      instance.goToStep(initialStep);
    }
  };

  useEffect(() => {
    if (!editData || mode !== "update") {
      return;
    }

    setMyData(buildEditMyData(editData));
  }, [editData, mode]);

  const assignvendorData = (val) => {
    // console.log("parent receive myData callback" ,val);
    setMyData((myData) => ({
      ...myData,
      ...val,
    }));
  };

  const handleStepChange = (e) => {
    // console.log("step change");
    // console.log(e);
    setActiveStep(e.activeStep - 1);
  };

  const [
    addAppUserDashboard,
    {
      data: appUserDashboardData,
      isLoading: appUserMenuIsLoading,
      error: appUserDashboardError,
    },
  ] = useAddAppUserDashboardMutation();

  const [updateAppUserDashboard, { isLoading: isUpdating }] =
    useUpdateAppUserDashboardMutation();

  const persistTenantDashboard = async (checkedItems) => {
    if (!isUpdateMode || !myData.recordId) {
      return { saved: false };
    }

    const finalList = formatDashboardPayload(checkedItems || []);

    try {
      const response = await updateAppUserDashboard({
        token: sessionStorage.getItem("access_token"),
        id: myData.recordId,
        data: { app_dashboard: finalList },
      }).unwrap();

      const savedList = Array.isArray(response?.body?.app_dashboard)
        ? response.body.app_dashboard
        : finalList;

      setMyData((prev) => ({
        ...prev,
        existingDashboard: cloneDashboardList(savedList),
        orderList: cloneDashboardList(checkedItems),
        finalProgramList: cloneDashboardList(checkedItems),
      }));
      refetch((previous) => previous + 1);
      return { saved: true };
    } catch (error) {
      const message =
        error?.data?.message || "Failed to save client dashboard";
      toast.error(message);
      return { saved: false };
    }
  };

  const handleComplete = async (latestReorderedList = null) => {
    const sourceList = latestReorderedList || myData.finalProgramList;
    const finalList = formatDashboardPayload(sourceList);

    if (finalList.length <= 0) {
      toast.error("Please select some options");
      return;
    }

    if (isUpdateMode) {
      if (!myData.recordId) {
        toast.error("Dashboard record not found");
        return;
      }

      try {
        await updateAppUserDashboard({
          token: sessionStorage.getItem("access_token"),
          id: myData.recordId,
          data: { app_dashboard: finalList },
        }).unwrap();
        toast.success("User dashboard updated");
        handleClose();
        setMyData({});
        refetch((previous) => previous + 1);
      } catch (error) {
        const message =
          error?.data?.message || "Something went wrong";
        toast.error(message);
      }
      return;
    }

    addAppUserDashboard({
      token: sessionStorage.getItem("access_token"),
      data: {
        tenant_id: myData.selectedVendorData.tenant_id,
        tenant_name: myData.selectedVendorData.name,
        user_type: myData.selectedUser,
        app_dashboard: finalList,
      },
    });
  };

  useMemo(() => {
    if (appUserDashboardData) {
      (() => {
        console.log("user dashboard  ", appUserDashboardData.body);
        toast.dismiss();
        toast.success("User dashboard created");
        handleClose();
        setMyData({});
        refetch((previous) => previous + 1);
      })();
    }
    if (appUserDashboardError) {
      console.log("user dashboard ", appUserDashboardError);
      toast.dismiss();
      if (appUserDashboardError.status === 409) {
        toast.error(appUserDashboardError.data.message, {
          id: "appUserDashboardError",
        });
      } else
        toast.error("Something went wrong", { id: "appUserDashboardError" });
      handleClose();
    }
  }, [appUserDashboardData, appUserDashboardError]);

  let custom = {
    enterRight: animate.fadeInRight,
    enterLeft: animate.fadeInLeft,
    exitRight: animate.fadeOutRight,
    exitLeft: animate.fadeOutLeft,
    intro: animate.animated,
  };
  return (
    <div>
      <div className="app-wizard-stepper">
      <Stepper activeStep={activeStep}>
        <Step
          label="Choose Client & User"
          children={
            <svg
              width="30px"
              height="30px"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 9H14M18 12H14M12 15.5C11.7164 14.3589 10.481 13.5 9 13.5C7.519 13.5 6.28364 14.3589 6 15.5M6.2 19H17.8C18.9201 19 19.4802 19 19.908 18.782C20.2843 18.5903 20.5903 18.2843 20.782 17.908C21 17.4802 21 16.9201 21 15.8V8.2C21 7.0799 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V15.8C3 16.9201 3 17.4802 3.21799 17.908C3.40973 18.2843 3.71569 18.5903 4.09202 18.782C4.51984 19 5.07989 19 6.2 19ZM10 9.5C10 10.0523 9.55228 10.5 9 10.5C8.44772 10.5 8 10.0523 8 9.5C8 8.94772 8.44772 8.5 9 8.5C9.55228 8.5 10 8.94772 10 9.5Z"
                stroke="#000000"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          }
        />
        <Step
          label="Choose Dashboard Items"
          children={
            <svg
              width="30px"
              height="30px"
              viewBox="0 0 24 24"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="🔍-Product-Icons"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="ic_fluent_phone_link_setup_24_regular"
                  fill="#212121"
                  fill-rule="nonzero"
                >
                  <path
                    d="M17.5,12 C17.7930736,12 18.0806075,12.024542 18.3607867,12.0717481 L18.5341163,12.7877987 C18.7930873,13.8615807 19.8734971,14.5221156 20.9472791,14.2631446 L21.0450624,14.2369258 L21.6461665,14.0580331 C22.0087308,14.5250263 22.2991223,15.0545692 22.4998264,15.6285394 L22.0525916,16.0588054 C21.2985339,16.7843546 21.2369524,17.9588704 21.8837443,18.7572658 L22.0250857,18.9142136 L22.4998264,19.3714606 C22.2992653,19.9450217 22.0091447,20.4742188 21.6469416,20.9409683 L21.0450624,20.7630742 C19.9857606,20.4500989 18.8733103,21.0551161 18.5603351,22.1144179 L18.5341163,22.2122013 L18.3607867,22.9282519 C18.0806075,22.975458 17.7930736,23 17.5,23 C17.2066096,23 16.918771,22.9754049 16.6383049,22.9280988 L16.4658837,22.2122013 C16.2069127,21.1384193 15.1265029,20.4778844 14.0527209,20.7368554 L13.9549376,20.7630742 L13.3530584,20.9409683 C12.9908553,20.4742188 12.7007347,19.9450217 12.5001736,19.3714606 L12.9474084,18.9411946 C13.7014661,18.2156454 13.7630476,17.0411296 13.1162557,16.2427342 L12.9749143,16.0857864 L12.5001736,15.6285394 C12.7007347,15.0549783 12.9908553,14.5257812 13.3530584,14.0590317 L13.9549376,14.2369258 C15.0142394,14.5499011 16.1266897,13.9448839 16.4396649,12.8855821 L16.4658837,12.7877987 L16.6383049,12.0719012 C16.918771,12.0245951 17.2066096,12 17.5,12 Z M13.75,2 C14.9926407,2 16,3.00735931 16,4.25 L16.0001627,11.1738934 C15.4723044,11.2985682 14.969311,11.4876006 14.4999221,11.7322512 L14.5,4.25 C14.5,3.83578644 14.1642136,3.5 13.75,3.5 L6.25,3.5 C5.83578644,3.5 5.5,3.83578644 5.5,4.25 L5.5,19.75 C5.5,20.1642136 5.83578644,20.5 6.25,20.5 L11.7327703,20.5010736 C12.0200482,21.0520148 12.3839565,21.5566422 12.8103588,22.0008195 L6.25,22 C5.00735931,22 4,20.9926407 4,19.75 L4,4.25 C4,3.00735931 5.00735931,2 6.25,2 L13.75,2 Z M8.74887095,17.5037644 L10.9999992,17.4989995 C10.9999992,18.0162111 11.0601751,18.5183676 11.1738934,18.9998373 L8.75112905,19.0037644 C8.33691596,19.0043862 8.00062441,18.6691057 7.99999915,18.2548926 C7.99937729,17.8406795 8.33465786,17.5043879 8.74887095,17.5037644 Z M17.5,16 C16.6993682,16 16.0503279,16.6715729 16.0503279,17.5 C16.0503279,18.3284271 16.6993682,19 17.5,19 C18.3006318,19 18.9496721,18.3284271 18.9496721,17.5 C18.9496721,16.6715729 18.3006318,16 17.5,16 Z"
                    id="🎨Color"
                  ></path>
                </g>
              </g>
            </svg>
          }
        />
        <Step
          label="Reorder & Confirm"
          children={
            <svg
              fill="#000000"
              width="30px"
              height="30px"
              viewBox="0 0 32 32"
              enable-background="new 0 0 32 32"
              version="1.1"
              xmlSpace="preserve"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <g id="Approved">
                <g>
                  <path d="M16,1C7.729,1,1,7.729,1,16s6.729,15,15,15s15-6.729,15-15S24.271,1,16,1z M16,29C8.832,29,3,23.168,3,16S8.832,3,16,3    s13,5.832,13,13S23.168,29,16,29z" />

                  <path d="M23.317,10.27l-10.004,9.36l-4.629-4.332c-0.403-0.377-1.035-0.356-1.413,0.047c-0.377,0.403-0.356,1.036,0.047,1.413    l5.313,4.971c0.192,0.18,0.438,0.27,0.683,0.27s0.491-0.09,0.683-0.27l10.688-10c0.403-0.377,0.424-1.01,0.047-1.413    C24.353,9.913,23.719,9.892,23.317,10.27z" />
                </g>
              </g>
            </svg>
          }
        />
      </Stepper>
      </div>
      <StepWizard
        instance={assignStepWizard}
        onStepChange={handleStepChange}
        transitions={custom}
        initialStep={initialStep}
      >
        <BasicSetup myData={myData} vendorDataCallback={assignvendorData} />

        <DashboardSetup
          myData={myData}
          vendorDataCallback={assignvendorData}
          isUpdateMode={isUpdateMode}
          persistTenantDashboard={persistTenantDashboard}
        />
        <LastStep
          myData={myData}
          completeCallback={handleComplete}
          vendorDataCallback={assignvendorData}
        />
      </StepWizard>
    </div>
  );
};

export default AppDashboardWizard;
